"use client";

import { FC, useContext } from "react";
import { MyGallery } from "components/organisms/MyGallery";
import { AppContext } from "lib/contexts";
export const MyGalleryLanding: FC = () => {
  const {
    state
  } = useContext(AppContext);
  return <div className="bg-background" data-sentry-component="MyGalleryLanding" data-sentry-source-file="index.tsx">{state.isLoggedIn && <MyGallery />}</div>;
};